import { Button, Grid, IconButton, Slider } from "@mui/material";
import { memo, useCallback, useMemo } from "react";
import { Instance as TinyColor } from 'tinycolor2'
import ColorSwatch from "../colorSwatch/colorSwatch";
import PlusIcon from "../../../assets/icons/PlusIcon";
import useStyles from './styles'

export type OpacitySliderProps = {
    value: TinyColor,
    onOpacityChange: (opacity: number) => void
    // swatches: TinyColor[],
    // onColorSelect: (value: TinyColor) => void,
    // onNewSwatchAdded: (value: TinyColor) => void
}

const OpacitySlider: React.FC<OpacitySliderProps> = ({value, onOpacityChange}) => {
    const color = useMemo(() => value.clone().setAlpha(1), [value])
    const { classes } = useStyles({color});
    const onChange = useCallback((event: Event, newValue: number | number[]) => {
        const opacity = Array.isArray(newValue) ? newValue[0] : newValue
        onOpacityChange(opacity/100)
    }, [onOpacityChange])
    return (
        <Slider  className={classes.root} onChange={onChange} value={value.getAlpha()*100} />
    );
}


export default memo(OpacitySlider)